import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import ModalFooter from '../../../UniformComponents/ModalFooter'
import Button from '../../../UniformComponents/Button'
import Panel from '../../../UniformComponents/Panel'
import Loader from '../../Loader'

@observer
class DashboardExport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedFormat: undefined,
            isExporting: false,
        }
    }

    renderOptions = () => {
        const { selectedFormat } = this.state
        return ['PDF', 'PNG'].map((format) => (
            <Panel
                onClick={() => { this.setState({ selectedFormat: format }) }}
                cssClass={selectedFormat === format ? 'active' : ''}
            >
                <h5>{format}</h5>
                {format === 'PDF'
                    ? <span>{i18n.t('dashboard.export.pdf')}</span>
                    : <span>{i18n.t('dashboard.export.png')}</span>}
                {selectedFormat === format && (
                    <i
                        className="far fa-check"
                    />
                )}
            </Panel>
        ))
    }

    render() {
        const {
            show, onClose, dashStore,
        } = this.props
        const { selectedFormat, isExporting } = this.state
        const { downloadAsPDF, downloadAsPNG } = dashStore

        return (
            <Modal show={show} onClose={onClose} cssClass="dashboardExport">
                <ModalHeader>
                    <h2 style={{ width: '100%', textAlign: 'center' }}>{i18n.t('dashboard.modal.download.title')}</h2>
                    <p>{i18n.t('download.modal.download_options.subtitle')}</p>
                </ModalHeader>
                <div className="modalBody">
                    {this.renderOptions()}
                    <Loader show={isExporting} />
                </div>
                <ModalFooter>
                    <div style={{
                        width: '100%', display: 'flex', justifyContent: 'center', gap: '16px',
                    }}
                    >
                        <Button
                            onClick={onClose}
                            cssClass="tertiary regular"
                            style={{ width: '150px' }}
                        >
                            {i18n.t('cancel')}
                        </Button>
                        <Button
                            cssClass={`primary regular ${!selectedFormat ? 'disabled' : ''}`}
                            style={{ width: '150px' }}
                            disabled={!selectedFormat}
                            onClick={async () => {
                                this.setState({ isExporting: true })
                                if (selectedFormat === 'PDF') await downloadAsPDF()
                                else await downloadAsPNG()
                                onClose()
                            }}
                        >
                            {i18n.t('download')}
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default DashboardExport
